import { Component, OnInit, EventEmitter } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { currencyOptionsConstant, titleOptionsConstant } from 'src/app/constants/service.constants';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-eap-study-team-view',
  templateUrl: './eap-study-team-view.component.html',
  styleUrls: ['./eap-study-team-view.component.scss']
})
export class EapStudyTeamViewComponent implements OnInit {

  formFields;
  titleOptions = titleOptionsConstant;

  studyTeamTeamForm = new UntypedFormGroup({
    prefix: new UntypedFormControl(null),
    first_name: new UntypedFormControl(null),
    middle_name: new UntypedFormControl(null),
    last_name: new UntypedFormControl(null),
    occupation: new UntypedFormControl(null),
    speciality: new UntypedFormControl(null),
    medical_license_number: new UntypedFormControl(null),
    address: new UntypedFormControl(null),
    postal_code: new UntypedFormControl(null),
    city: new UntypedFormControl(null),
    state: new UntypedFormControl(null),
    country: new UntypedFormControl(null),
    preferred_contact_method: new UntypedFormControl(null),
    email_address: new UntypedFormControl(null),
    phone_number: new UntypedFormControl(null),
    ext_phone_number: new UntypedFormControl(null),
    other_phone_number: new UntypedFormControl(null),
    ext_other_phone_number: new UntypedFormControl(null),
    fax: new UntypedFormControl(null),
    ext_fax: new UntypedFormControl(null),
    organisation_name: new UntypedFormControl(null),
    user_role: new UntypedFormControl(null),
    cv_upload_attachment: new UntypedFormControl(null),
    notes: new UntypedFormControl(null)
  });

  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  formData: FormData;
  files: any[];
  uploadInput: EventEmitter<any>;
  humanizeBytes: Function;
  dragOver: boolean;
  currencyOptions = currencyOptionsConstant;

  /**
   * Constructor: Initializes the component with default values
   */
  constructor(
  ) {
  }

  /**
   * Initializes the component. No-op by default. Override this method in components
   * that need to fetch data or perform other initialization tasks.
   */
  ngOnInit() {
  }

  operations = [
    { name: 'Save', type: 'submit', callback: this.save, self: this }
  ]

  /**
   * Executes the callback function provided in the operation object.
   * This method is triggered when a callback operation is emitted from the grid,
   * and it invokes the callback method attached to the operation.
   *
   * @param opr - The operation object containing the callback function to be executed.
   */
  onCallbackOperation(opr) {
    opr.callback();
  }

  /**
   * Saves the form data to the database.
   * This method is the callback function for the 'Save' operation in the grid.
   * It is invoked when the user clicks the 'Save' button in the grid.
   */
  save() {

  }

  /**
   * Returns a comma-separated list of file names from the files array.
   * If the files array is empty or undefined, an empty string is returned.
   *
   * @returns {string} A comma-separated list of file names.
   */
  showFiles() {
    let files = '';
    if (this.files && this.files.length > 0) {
      for (let i = 0; i < this.files.length; i++) {
        files += this.files[i].name;
        if (!(this.files.length - 1 === i)) {
          files += ',';
        }
      }
    }
    return files;
  }

  /**
   * Initiates the upload process for all files.
   * This method constructs an upload event with the necessary details
   * such as the backend endpoint URL, HTTP method, and any additional data.
   * It then emits this event to trigger the upload process.
   * Additionally, it clears the files array to reset the file list before uploading.
   */
  startUpload(): void {
    const event: any = {
      type: 'uploadAll',
      url: 'your-path-to-backend-endpoint',
      method: 'POST',
      data: { foo: 'bar' },
    };
    this.files = [];
    this.uploadInput.emit(event);
  }

  /**
   * Cancels the upload for a file with the given id.
   * This method emits a cancel event with the id of the file to be cancelled.
   * It is invoked when the user clicks the cancel button in the file list.
   * @param {string} id - The id of the file to be cancelled.
   */
  cancelUpload(id: string): void {
    this.uploadInput.emit({ type: 'cancel', id: id });
  }

  /**
   * Handles the output of the uploader component.
   * This method is invoked by the uploader component when there is an output.
   * It handles the different types of output events such as 'allAddedToQueue', 'addedToQueue', 'uploading', 'removed', 'dragOver', 'dragOut', and 'drop'.
   * Based on the type of event, it updates the files array accordingly.
   * It also calls the showFiles() method to update the file list UI.
   * @param {any} output - The output of the uploader component.
   */
  onUploadOutput(output: any | any): void {

    if (output.type === 'allAddedToQueue') {
    } else if (output.type === 'addedToQueue') {
      this.files.push(output.file); // add file to array when added
    } else if (output.type === 'uploading') {
      // update current data in files array for uploading file
      const index = this.files.findIndex(file => file.id === output.file.id);
      this.files[index] = output.file;
    } else if (output.type === 'removed') {
      // remove file from array when removed
      this.files = this.files.filter((file: any) => file !== output.file);
    } else if (output.type === 'dragOver') {
      this.dragOver = true;
    } else if (output.type === 'dragOut') {
    } else if (output.type === 'drop') {
      this.dragOver = false;
    }
    this.showFiles();
  }
}
